import pick from 'lodash/pick';
import omit from 'lodash/omit';

import React from 'react';
import PropTypes from 'prop-types';

import DropdownComponent from './Component';

export default DropdownComponent;

const DropdownContainer = ({ input, ...props }) => {

  const reduxFormProperties = pick(
    input, ['value', 'onChange']
  );

  const dropdownProperties = omit(props, ['meta']);
  return (
    <DropdownComponent
      {...dropdownProperties}
      {...reduxFormProperties}
    />
  );
};

DropdownContainer.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired,

  options: PropTypes.array.isRequired
};

export { DropdownContainer as ReduxFormWrapper };
